// about-page.js
document.addEventListener('DOMContentLoaded', function () {

  // Scroll to Top
  const scrollBtn = document.querySelector('.about-scroll-top');
  if (scrollBtn) {
    window.addEventListener('scroll', function () {
      scrollBtn.style.display = window.scrollY > 300 ? 'flex' : 'none';
    });
    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

});
